import type { NextPage } from 'next'
import { joinClassnames } from 'helpers/classNames'
import styles from '../../styles/form/form.module.scss'
import { Type } from 'types/type'
import { CSSProperties } from 'react'

interface Props {
  children: any
  smallMargins?: boolean
  smallPadding?: boolean
  alignLeft?: boolean
  noPadding?: boolean
  type?: Type
  shadow?: Type
  noBorder?: boolean
  fullWidth?: boolean
  style?: CSSProperties
}

const FormComponent: NextPage<Props> = (props: Props) => {
  const className = joinClassnames([
    styles.container,
    props.smallMargins && styles.small_margins,
    props.noPadding && styles.no_padding,
    props.smallPadding && styles.small_padding,
    props.alignLeft && styles.align_left,
    !props.noBorder && styles.border,
    props.type === Type.t1 && styles.From__type1,
    props.type === Type.t2 && styles.From__type2,
    props.type === Type.t3 && styles.From__type3,
    props.type === Type.t4 && styles.From__type4,
    props.type === Type.t5 && styles.From__type5,
    props.type === Type.t6 && styles.From__type6,
    props.type === Type.t7 && styles.From__type7,
    props.type === Type.t8 && styles.From__type8,
    props.shadow === undefined && styles.shadow,
    props.shadow === Type.t1 && styles.shadow_1,
    props.fullWidth && styles.full_width,
  
  ])

  return (
    <div className={className} style={props.style}>
      {props.children}
    </div>
  )
}

export default FormComponent
